/**
 * Created by Mark on 23/11/2016.
 */

import ENVIRONMENT_CONSTANTS from './environment.js'

export default {
    LOGIN_URL: ENVIRONMENT_CONSTANTS.BASE_URL + '/loginController/attemptLogIn',
    REFRESH_URL: ENVIRONMENT_CONSTANTS.BASE_URL + '/HandShake/shake',
    PERMISSIONS: ENVIRONMENT_CONSTANTS.BASE_URL + 'userDataController/getUnixPermissions',
    USER: ENVIRONMENT_CONSTANTS.BASE_URL + 'userDataController/getUserData',
    PRODUCTS: ENVIRONMENT_CONSTANTS.BASE_URL + 'buyProductController/getProductInformation',
    VIST_PRODUCTS: ENVIRONMENT_CONSTANTS.BASE_URL + 'buyProductController/sendNotification',
    LOGIN_USER: 'LOGIN_USER',
    LOGOUT_USER: 'LOGOUT_USER',
    LOCKOUT_TIMER_ID : 'LU1234',
    GRANT_PERMISSION : "GRANT_PERMISSION",
    GET_USER_DATA:'GET_USER_DATA'
}


// WEBPACK FOOTER //
// ./src/constants/authnetication.js